import {all, call, put, select, takeLatest} from 'redux-saga/effects';

import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';
import {getJsonFromLocalStorage, storeLocally} from 'utils/localStorage';

import {
  CHANGE_PASSWORD,
  changePasswordFailed,
  changePasswordSuccess,
  UPDATE_PROFILE,
  updateProfileFailed,
} from 'actions/accountActions';
import {signinSuccess} from 'actions/userActions';

function* updateProfile(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `user/${action.details._id}`;
  const u = {
    email: action.details.email,
    firstName: action.details.firstName,
    lastName: action.details.lastName,
  };
  if (action.details.avatar) u.avatar = action.details.avatar;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(u),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);
    const storedUser = getJsonFromLocalStorage('user');
    const {user} = response;
    const newUser = {
      ...storedUser,
      user: {
        ...storedUser.user,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        avatar: user.avatar,
      },
    };
    storeLocally('user', newUser);
    if (response.user.newEmail) {
      yield put(
        updateProfileFailed(
          `your new email ${response.user.newEmail} need validation.`
        )
      );
    } else {
      yield put(signinSuccess(newUser));
    }
  } catch (err) {
    let errorMessage = 'Something went wrong';
    if (err.message) {
      errorMessage = err.message;
    }
    yield put(updateProfileFailed(errorMessage));
  }
}

function* changePassword(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `user/${action.details._id}/updatePassword`;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);
    yield put(changePasswordSuccess(response));
  } catch (err) {
    let errorMessage = 'Something went wrong';
    if (err.message) {
      errorMessage = err.message;
    }

    yield put(changePasswordFailed(errorMessage));
  }
}

export default function* accountSaga() {
  yield all([
    takeLatest(UPDATE_PROFILE, updateProfile),
    takeLatest(CHANGE_PASSWORD, changePassword),
  ]);
}
